import { authActions } from "@/store/actions";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";

const useHeader = () => {
  const { push } = useRouter();
  const dispatch = useDispatch<any>();
  const logout = () => {
    dispatch(authActions.logoutUser());
  };

  return {
    logout,
  };
};

export default useHeader;
